<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group id="input-group-1" label="Título:" label-for="input-1" :description="checkRemaining(form.title.length, 100)">
          <b-form-input id="input-1" v-model="form.title" required placeholder="Ingrese el título del proyecto" maxlength="100" trim></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" label="Palabras clave:" label-for="input-1" :description="checkRemaining(form.keyWords.length, 5)">
          <multiselect v-model="form.keyWords" :options="form.keyWords" :multiple="true" :taggable="true" @tag="addTag" label="name" track-by="name"
          tag-placeholder="Presiona enter para agregar" selected-label="Seleccionado"
            placeholder="Ingrese las palabras clave">
          </multiselect>
        </b-form-group>
        <b-form-group
          label="Resumen:"
          label-for="textarea-formatter"
          :description="checkRemaining(form.resume.length, 1150)"
          class="mb-0"
        >
          <b-form-textarea
            id="textarea-formatter"
            rows="5"
            v-model="form.resume"
            maxlength="1150"
            placeholder="Descripción breve del proyecto"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group
          label="Objetivo de desarrollo sostenible o foco de la misión de sabios (máx. 2 ODS - máx. 2 focos de la misión de sabios):"
          label-for="textarea-formatter"
          :description="checkRemaining(form.objectives.length, 256)"
          class="mb-0"
        >
          <b-form-textarea
            id="textarea-formatter"
            v-model="form.objectives"
            rows="3"
            placeholder="Objetivos que cumple el proyecto"
            maxlength="256"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group
          label="Producto entregado:"
          label-for="textarea-formatter"
          :description="checkRemaining(form.finishedProduct.length, 256)"
          class="mb-0"
        >
          <b-form-textarea
            id="textarea-formatter"
            v-model="form.finishedProduct"
            rows="3"
            placeholder="Breve descripción de el/los productos entregados..."
            maxlength="256"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group
          label="Impacto obtenido:"
          label-for="textarea-formatter"
          :description="checkRemaining(form.achievedImpact.length, 256)"
          class="mb-0"
        >
          <b-form-textarea
            id="textarea-formatter"
            rows="3"
            v-model="form.achievedImpact"
            placeholder="Breve descripción de el/los impactos obtenidos..."
            maxlength="256"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-col xl="3">
        <b-button variant="primary" @click="save()">{{ form.id ? 'Guardar' : 'Crear'}}</b-button>
        <b-button variant="light" class="btn-sm" @click="cleanAndBack()">Cancelar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import apiClient from '@/services/axios'
import Swal from 'sweetalert2'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  components: {
  },
  name: 'academicProjectCreate',
  props: {
    isEditing: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        id: null,
        title: '',
        resume: '',
        keyWords: [],
        objectives: '',
        finishedProduct: '',
        achievedImpact: '',
      },
    }
  },
  created: function () {
  },
  mounted: function () {
    if (this.isEditing.value) {
      apiClient.get(`/academic-projects/${this.isEditing.id}`).then(response => {
        this.form = response.data
        this.form.keyWords = JSON.parse(this.form.keyWords)
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    }
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  methods: {
    setData() {
    },
    checkRemaining(x, y) {
      return (y === 5) ? (y - x) + ' palabras restantes' : (y - x) + ' caracteres restantes'
    },
    addTag (newTag) {
      if (newTag.length > 25) {
        return Toast.fire({
          icon: 'warning',
          title: 'La palabra clave no puede tener mas de 25 caracteres',
        })
      } else if (this.form.keyWords.length >= 5) {
        return Toast.fire({
          icon: 'warning',
          title: 'El limite de palabras clave es 5',
        })
      }
      const tag = {
        name: newTag,
      }
      this.form.keyWords.push(tag)
    },
    save() {
      if (this.form.title.length < 1) {
        return Toast.fire({
          icon: 'warning',
          title: 'El título no debe estar vacío',
        })
      }
      if (this.form.resume.length < 1) {
        return Toast.fire({
          icon: 'warning',
          title: 'El resumen no debe estar vacío',
        })
      }
      if (!this.isEditing.value) {
        console.log(this.isEditing)
        apiClient.post('/academic-projects', { form: this.form }).then(response => {
          Toast.fire({
            icon: 'success',
            title: 'Projecto agregado correctamente a su hoja de vida académica',
          })
          this.cleanAndBack(1)
        }).catch(err => {
          Toast.fire({
            icon: 'error',
            title: 'Ooops ocurrio un error' + showErrorMessage(err),
          })
        })
      } else {
        apiClient.patch('/academic-projects/' + this.isEditing.id, { form: this.form }).then(response => {
          Toast.fire({
            icon: 'success',
            title: 'Projecto guardado correctamente en su hoja de vida académica',
          })
          this.cleanAndBack(1)
        }).catch(err => {
          Toast.fire({
            icon: 'error',
            title: 'Ooops ocurrio un error' + showErrorMessage(err),
          })
        })
      }
    },
    cleanAndBack(type) {
      this.$emit('clean', type)
    },
  },
}
</script>
